import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { breadcrumbsConstants } from '../data/breadcrumbsConstants'
import { capitalizeFirstLetter } from '../utils/index'

const Breadcrumbs = () => {
  const { t } = useTranslation()
  const location = useLocation()

  let currentLink = ''

  const replaceHyphensAndUnderscoresWithSpaces = (str) => {
    return str.replace(/[-_]/g, ' ') // Using regular expression with 'g' flag to replace all occurrences
  }

  const crumbs = location.pathname
    .split('/')
    .filter((el) => el !== '')
    .map((crumb) => {
      const match = breadcrumbsConstants.find((el) => el.value === crumb)
      const translatedCrumb = match
        ? match.labelKey
          ? t(match.labelKey)
          : match.label
        : decodeURIComponent(replaceHyphensAndUnderscoresWithSpaces(crumb))
      currentLink += `/${crumb}`

      return (
        <li key={crumb}>
          <Link to={currentLink}>{capitalizeFirstLetter(translatedCrumb)}</Link>
        </li>
      )
    })

  return (
    <div className="text-sm breadcrumbs font-extrabold text-secondary">
      <ul>{crumbs}</ul>
    </div>
  )
}

export default Breadcrumbs
